export class StorageHandler {

    public static setLocalStorage(name: string, value: string) {
        localStorage.setItem(name, value);
    }

    public static getLocalStorage(name: string): any {
        return localStorage.getItem(name);
    }

    public static removeLocalStorage(name: string) {
        localStorage.removeItem(name);
    }

    public static setSessionStorage(name: string, value: string) {
        sessionStorage.setItem(name, value);
    }

    public static deleteSessionStorage(name: string) {
        sessionStorage.removeItem(name);
    }

    public static getSessionStorage(name: string): any {
        return sessionStorage.getItem(name);
    }

    public static clearStorages(): void {
        sessionStorage.clear();
        localStorage.clear();
    }
    
}